import React, { useState } from 'react';
import { useAuthStore } from '../../../services/useAuthStore';
import useBillingStore from '../../../services/useBillingStore';
import SubscriptionOverview from './SubscriptionOverview';
import PlanCards from './PlanCards';
import ChangePlanDialog from './ChangePlanDialog';
import BillingHistory from './BillingHistory';
import './BillingManagement.css';

const BillingManagement = () => {
  const { membership } = useAuthStore();
  const { subscription, fetchSubscription } = useBillingStore();
  const [showPlanCards, setShowPlanCards] = useState(false);
  const [changingPlan, setChangingPlan] = useState(null);

  // Access control: Only ADMIN and FINANCE (role levels 1 and 4)
  const userRole = membership?.role;
  const hasAccess = userRole === 'admin' || userRole === 'finance';

  if (!hasAccess) {
    return (
      <div className="co-section">
        <h2>Faturamento e Assinatura</h2>
        <p className="co-error">
          Acesso negado: Você não tem permissão para acessar informações de faturamento.
        </p>
      </div>
    );
  }

  const handleChangePlan = () => {
    setShowPlanCards(true);
  };

  const handleSelectPlan = (plan) => {
    setChangingPlan(plan);
  };

  const handlePlanChangeSuccess = () => {
    setChangingPlan(null);
    setShowPlanCards(false);
    fetchSubscription();
  };

  return (
    <div className="co-section billing-management">
      <h2>Faturamento e Assinatura</h2>
      <p className="co-section-subtitle">
        Gerencie sua assinatura, visualize planos disponíveis e acompanhe o histórico de cobranças.
      </p>

      <div className="co-group">
        <SubscriptionOverview onChangePlan={handleChangePlan} />
      </div>

      {showPlanCards && (
        <div className="co-group">
          <div className="section-header">
            <h3>Planos Disponíveis</h3>
            <button
              className="btn-secondary"
              onClick={() => setShowPlanCards(false)}
            >
              Ocultar Planos
            </button>
          </div>
          <PlanCards
            currentPlanId={subscription?.plan_id}
            onSelectPlan={handleSelectPlan}
          />
        </div>
      )}

      <div className="co-group">
        <BillingHistory />
      </div>

      {changingPlan && subscription && (
        <ChangePlanDialog
          currentPlan={{
            id: subscription.plan_id,
            name: subscription.plan_name,
            price: subscription.price
          }}
          newPlan={changingPlan}
          onClose={() => setChangingPlan(null)}
          onSuccess={handlePlanChangeSuccess}
        />
      )}
    </div>
  );
};

export default BillingManagement;
